import React from 'react';
import { useDispatch } from 'react-redux';
import { change } from 'redux-form';
import { Link } from 'react-scroll';

function ContactScrollLink({ subject, children, ...props }) {
    const dispatch = useDispatch();

    function prefillSubject() {
        dispatch(change('mainContactForm', 'subject', subject));
    }

    return (
        <Link to="contact" smooth={true} offset={-80} onClick={prefillSubject} {...props}>
            {children}
        </Link>
    );
}

export default ContactScrollLink;
